// Update https://app.hubspot.com/design-manager/40039512/code/135044318828 as well
export const getOverrideText = (brandKey: string, text: string): string => {
  if (brandKey === 'united-kingdom-lsw-london') {
    return text
      .replaceAll('HK$2,000', 'HK$500')
      .replaceAll('SG$400', 'SG$100')
      .replaceAll('RM1,000', 'RM300')
      .replaceAll('~250 USD', '~65 USD')
  }
  return text
}
